import { type PropsWithChildren } from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

import { isSentryEnabled } from "../utils/sentry";
import { ErrorReporter } from "./createErrorHandler";
import { ErrorFallback } from "./ErrorFallback";
import { SentryErrorBoundary } from "./SentryErrorBoundary";

export type ErrorBoundaryProps = PropsWithChildren<{
  errorHandlerReport: ErrorReporter;
}>;

export const BaseErrorBoundary = ({ errorHandlerReport, children }: ErrorBoundaryProps) => (
  <ReactErrorBoundary
    onError={(error) =>
      errorHandlerReport(typeof error === "string" || error instanceof Error ? error : "Unknown error occurred")
    }
    FallbackComponent={ErrorFallback}
  >
    {children}
  </ReactErrorBoundary>
);

export const ErrorBoundary = ({ errorHandlerReport, children }: ErrorBoundaryProps) => {
  if (!isSentryEnabled()) {
    return <BaseErrorBoundary errorHandlerReport={errorHandlerReport}>{children}</BaseErrorBoundary>;
  }
  return <SentryErrorBoundary errorHandlerReport={errorHandlerReport}>{children}</SentryErrorBoundary>;
};
